import CityServicePage from "@/pages/city-service/CityServicePage";
import { etobicokeResidential } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={etobicokeResidential} />; }
